import { ref } from 'vue'
import { fetchSettings, putSettings } from '~/api/settingsApi'
import { useUserStore } from '~/composables/useUserStore'

interface StoredMediaItem {
  _id?: string;
  id: string;
  title: string;
  tag: string;
  categoryTitle?: string;
  mediaUrl: string;
  mediaType: 'image' | 'video' | null;
}

interface Settings {
  _id?: string;
  homeSlider: {
    _id?: string;
    slides: StoredMediaItem[];
  };
  fields: {
    _id?: string;
    categories: StoredMediaItem[];
  };
  handpickedWorks: {
    _id?: string;
    areas: {
      id: number;
      works: any[];
    }[];
  };
  collectReads: {
    _id?: string;
    reads: any[];
  };
  downloadNow: {
    _id?: string;
    appStoreUrl: string;
    playStoreUrl: string;
    media: StoredMediaItem | null;
  };
}
 
export function useSettingsStore() {
  const settings = ref<Settings | null>(null)

  const { token } = useUserStore();

  const getSettings = async (): Promise<Settings | null> => {
    try {
      // TODO: Implement API call to fetch settings
      const response = await fetchSettings()
      settings.value = response
      return response
    } catch (error) {
      console.error('Failed to fetch settings:', error)
      return null
    }
  }

  const updateSettings = async (newSettings: Settings): Promise<boolean> => {
    try {
      // TODO: Implement API call to update settings
      const response = await putSettings(newSettings, token.value)

      const data = response
      settings.value = data
      return true
    } catch (error) {
      console.error('Failed to update settings:', error)
      throw error
    }
  }

  return {
    settings,
    getSettings,
    updateSettings,
  }
} 